<template>
  <vue-typeahead-bootstrap
    v-model="search"
    :data="items"
    :serializer="(item) => item.fantasy_name"
    :placeholder="placeholder"
    @input="findLegalPeople"
    @hit="legal_person = $event"
    class="form-control form-control-custom"
    :class="[stateClass]"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";
import { debounce } from "lodash";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/esm/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/esm/mixins/form-state";

import { sortKeys } from "bootstrap-vue/esm/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/esm/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {},
    placeholder: {
      type: String,
      default: "Buscar ...",
    },
  })
);
export default {
  components: { VueTypeaheadBootstrap },
  props,
  mixins: [formControlMixin, formStateMixin],
  data: () => ({
    legal_person: null,
    search: "",
    items: [],
  }),
  computed: {},
  methods: {
    ...mapActions("legal_people", ["ActionFind", "ActionFindById"]),
    findLegalPeople: debounce(async function () {
      var items = await this.ActionFind(this.search);
      this.items = items;
    }, 500),
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.legal_person = null;
      }
    },
    legal_person: function () {
      if (this.legal_person) {
        this.search = this.legal_person.fantasy_name;
        this.items = [this.legal_person];
        this.$emit("input", this.legal_person.id);
      } else {
        this.$emit("input", null);
      }
    },
  },
  async created() {
    if (this.value) {
      this.legal_person = await this.ActionFindById(this.value);
    }
  },
};
</script>

<style>
</style>
